module.exports = __webpack_public_path__ + "img/logoDarkVer.282d8b41.svg";